// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__1qDln","heading":"Banner_heading__25zh0"};